import React from 'react';

import _ from 'lodash';

// components
import { AdditionalInsured } from './AdditionalInsured';
import { PaymentSummary } from './PaymentSummary';
import { EndorsementHeader } from './EndorsementHeader';
import { DrawerCoverageSummary } from './DrawerCoverageSummary';

// utils
import {
  getCoverages,
  getConsolidatesKeys,
  generateAIText,
} from './endorsement.utils';
import { ProductTypes } from '../../../types';
import InsuredInformationBase from './InsuredInformation';
import { withShowable } from '../lib/withShowable';

const InsuredInformation = withShowable(InsuredInformationBase);

export const P100QuoteMidTermEndorsementDrawer = ({ quote: data }) => {
  const {
    effectiveDate,
    additionalInsureds,
    paymentData,
    quoteNumber,
    companyName,
    address,
    endorsementCoverages,
    isAIApplicable,
    coverageConsolidatedKeys,
  } = React.useMemo(() => {
    return {
      additionalInsureds: _.get(data, 'additionalInsureds', []),
      effectiveDate: _.get(data, 'effectiveDate'),
      companyName: data?.companyName,
      paymentData: {
        ..._.pick(data, [
          'totalPremium',
          'coveragesAdded',
          'coveragesRemoved',
          'coveragesUpdated',
        ]),
      },
      address: data?.address,
      quoteNumber: _.get(data, 'quoteNumber'),
      endorsementCoverages: getCoverages({ ...data }, ProductTypes.p100),
      isAIApplicable: generateAIText(data),
      coverageConsolidatedKeys: getConsolidatesKeys(data).filter(
        (key) => key !== 'additionalInsureds' && key !== 'insuredInfo'
      ),
    };
  }, [data]);

  const hasInsuredInfo = data?.coveragesUpdated?.includes('insuredInfo');

  return (
    <>
      <EndorsementHeader
        effectiveDate={effectiveDate}
        endDate={data.endDate}
        number={quoteNumber}
        label="Quote#"
      />
      <InsuredInformation
        show={hasInsuredInfo}
        insuredInfo={{ ...address, companyName }}
      />
      <DrawerCoverageSummary
        current={endorsementCoverages}
        existingKeys={coverageConsolidatedKeys}
      />
      <AdditionalInsured
        additionalInsureds={additionalInsureds}
        isAIApplicable={isAIApplicable}
      />
      <PaymentSummary
        data={{
          hasInsuredInfo,
          coverageConsolidatedKeys,
          isAIApplicable,
          ...paymentData,
        }}
      />
    </>
  );
};
